<script setup lang="ts">
import {onMounted, onUnmounted} from "vue";

function keyboardBlackHole(e: KeyboardEvent) {
  e.preventDefault();
  e.stopPropagation();
}

onMounted((() => {
  window.addEventListener("keydown", keyboardBlackHole)
}))
onUnmounted(() => {
  window.removeEventListener("keydown", keyboardBlackHole);
})
</script>
<template>
  <div class="tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-fixed tw-top-0 tw-left-0 tw-z-[99991] tw-bg-transparent">
    <q-spinner-dots
      class="tw-m-4 tw-size-[70px] tw-text-[60px] mobile:tw-text-[50px] mobile:tw-size-[50px]"
      indeterminate
      color="primary"
    />
    <div
      class="tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-fixed tw-top-0 tw-left-0 tw-bg-namaBackground-deep-light dark:tw-bg-namaBackground-deep-dark tw-opacity-20 dark:tw-opacity-10"></div>
  </div>
</template>
<style scoped>
</style>
